export var MediaQueries;
(function (MediaQueries) {
    MediaQueries[MediaQueries["XS"] = 425] = "XS";
    MediaQueries[MediaQueries["XSM"] = 576] = "XSM";
    MediaQueries[MediaQueries["SM"] = 768] = "SM";
    MediaQueries[MediaQueries["MD"] = 992] = "MD";
    MediaQueries[MediaQueries["LG"] = 1200] = "LG";
})(MediaQueries || (MediaQueries = {}));
